/** Pueden usar el panel (login y rutas de negocio). */
export const PANEL_ROLES = ['ADMINISTRADOR', 'USUARIO'];

/** Solo administración de usuarios. */
export const ADMIN_ROLES = ['ADMINISTRADOR'];
